import React from "react";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import PropTypes from "prop-types";

export const ShortDate = ({ isPrimerEquipo }) => {
  const currentDate = new Date();
  const formattedDate = format(currentDate, "d MMMM yyyy", { locale: es });
  const [day, month, year] = formattedDate.split(" ");
  const formattedDay = `${day}º`;
  const customFormattedDate = `${formattedDay} ${month} ${year}`;
  const textClass = isPrimerEquipo ? "red-link" : "blue-link";
  return (
    <div className="text-container">
      <a className={textClass} href="/">
        {isPrimerEquipo ? "PRIMER EQUIPO" : "EQUIPO FEMENINO"}
      </a>

      <a className="grey-text" href="/">
        {customFormattedDate}
      </a>
    </div>
  );
};
ShortDate.propTypes = {
  isPrimerEquipo: PropTypes.bool.isRequired,
};
